export const marketPlaceFormRef = 'market-place-form-ref';
export const marketplaceType = 'marketplace-form';
